var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content has-text-centered"},[(_vm.status == 'failed')?_c('div',[_c('failed',{attrs:{"reason":_vm.failureReason}})],1):_vm._e(),(_vm.status != 'failed')?_c('div',[_c('success')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }